<div class="item-wrapper d-flex justify-content-center align-item-center flex-direction-column">
  <div (click)="selectType(callerType)"
       [ngClass]="classState ? 'green-bg text-white': 'grey-border grey-text '"
       class="item m-x-2 d-flex justify-content-center align-item-center cursor-pointer">
    <img  [src]="iconUrl" alt="" class="opacity-3">
  </div>
  <p class="text-center m-t-1" translate="{{title}}"></p>
</div>
